import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Phone, MapPin, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img src="/nexstep_logo_dark.png" alt="NexStep HR Solutions" className="h-10" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Strategic HR Consulting for Investors and Growth Stage Organizations
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.linkedin.com/company/nexstephr/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-slate-800 text-slate-400 hover:bg-amber-500 hover:text-slate-900 transition-all duration-200">
                <Linkedin size={18} />
              </a>
              <a
                href="mailto:consult@nexstephr.com"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-slate-800 text-slate-400 hover:bg-amber-500 hover:text-slate-900 transition-all duration-200">
                <Mail size={18} />
              </a>
              <a
                href="https://wa.me/918928440225"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-slate-800 text-slate-400 hover:bg-amber-500 hover:text-slate-900 transition-all duration-200">
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 tracking-wide">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/who-we-work-with" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  Who We Work With
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/our-approach" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  Our Approach
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 tracking-wide">Core Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services#org-effectiveness" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  Organizational Effectiveness
                </Link>
              </li>
              <li>
                <Link to="/services#due-diligence" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  HR Due Diligence
                </Link>
              </li>
              <li>
                <Link to="/services#fractional-chro" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  Fractional CHRO Services
                </Link>
              </li>
              <li>
                <Link to="/services#leadership-search" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  Leadership Search
                </Link>
              </li>
              <li>
                <Link to="/services#hr-technology" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  HR Technology Advisory
                </Link>
              </li>
              <li>
                <Link to="/services#manager-capability" className="text-slate-400 text-sm hover:text-amber-400 transition-colors">
                  Manager Capability & Coaching
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-4 tracking-wide">Reach Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0 text-amber-500" />
                <span>Mumbai | Pune | Hyderabad</span>
              </li>
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <Mail size={16} className="mt-0.5 flex-shrink-0 text-amber-500" />
                <a href="mailto:consult@nexstephr.com" className="hover:text-amber-400 transition-colors">
                  consult@nexstephr.com
                </a>
              </li>
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <Phone size={16} className="mt-0.5 flex-shrink-0 text-amber-500" />
                <a href="tel:+918928440225" className="hover:text-amber-400 transition-colors">
                  +91-8928440225
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-slate-500 text-sm">
              © {currentYear} NexStep HR Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;